/**
 * User Declared Questions for Audit Report Analysis
 * This is the single source of truth for all user questions
 */

export interface UserQuestion {
  id: string;
  question: string;
  subQuestion?: string;
  type?: 'select';
  options?: string[];
}

export const USER_QUESTIONS: UserQuestion[] = [
  {
    id: "shares_ratio_consistency",
    question: "Unless there has been an issue of shares or buy back of shares, is ratio of basic and diluted eps to PAT same across all periods?",
    subQuestion: "Has there been any issue of shares or buyback of shares?"
  },
  {
    id: "eps_recalculation",
    question: "If there is a change in FV or Bonus issue, is EPS for previous periods recalculated?"
  },
  {
    id: "overdraft_cce_classification",
    question: "Is overdraft which is integral part of cash management shown as CCE and not under financing cash flows?"
  },
  {
    id: "interim_dividend_details",
    question: "Do results give details of any interim dividend paid/declared?"
  },
  {
    id: "capital_raised_usage",
    question: "Do results give details of usage on capital raised?"
  },
  {
    id: "accounting_policy_changes",
    question: "Are changes in accounting policies/ estimates, material transactions highlighted with impact?"
  },
  {
    id: "prior_period_restatement",
    question: "When there are material prior period errors and accounting policy changes are past results restated?"
  },
  {
    id: "ind_as_adoption_disclosures",
    question: "In case of first-time adoption of IND AS are adequate disclosures made?"
  },
  {
    id: "goodwill_change_warning",
    question: "If Goodwill has changed compared to previous period, raise warning unless it is impaired and there is a note.",
    subQuestion: "It's ok if it is due to forex translation if there are foreign subsidiaries"
  },
  {
    id: "exceptional_items_note",
    question: "Do exceptional items have corresponding notes or detailed disclosure?"
  },
  {
    id: "pre_consolidation_forex_figures",
    question: "Are figures given in the para dealing with components in review/audit report before consolidation/forex adjustments?"
  },
  {
    id: "previous_auditor_different",
    question: "Is the previous auditor different from the current auditor?"
  },
  {
    id: "other_auditors_mention",
    question: "Are components reviewed/audited by other auditors mentioned in review/audit report?"
  },
  {
    id: "first_year_firm_previous_auditor",
    question: "Is there a paragraph on who has done review/audit in previous year and if report is modified for first year firm?"
  },
  {
    id: "sep_qr_vs_hy",
    question: "Do any items (other than Purchases and Changes in Inventories) differ by more than 50% when September quarter ×2 is compared with HY results?"
  },
  {
    id: "dec_qr_vs_9m",
    question: "Do any items (other than Purchases and Changes in Inventories) differ by more than 50% when December quarter ×3 is compared with 9M results?"
  },
  {
    id: "ytd_match_prev_plus_current",
    question: "Do YTD figures equal the sum of the previous quarter's figures and the current quarter (after rounding)?"
  },
  {
    id: "hy_quarters_match",
    question: "Do the two quarters add up correctly to the HY results?"
  },
  {
    id: "standalone_vs_consol_diff",
    question: "Do standalone vs. consolidated differences (on a per-month basis) exceed 25% in Results, Assets & Liabilities, Cash Flow, or Segment?",
    subQuestion: "Exclude Other Income, Investments, OCI, and Associates/JV"
  },
  {
    id: "only_associates_jv",
    question: "If only Associates/JV exist (no subsidiaries), do standalone and consolidated figures tally?",
    subQuestion: "Exceptions allowed for Other Income, Investments, and Reserves"
  },
  {
    id: "associates_investment_reconciliation",
    question: "If Associates/JV exist, does Opening investment + Associate TCI – Dividends = Closing investment (equity method)?",
    subQuestion: "Include forex changes if applicable"
  },
  {
    id: "audit_profit_loss_consistency",
    question: "Is profit or loss consistently mentioned across the audit/review report?"
  },
  {
    id: "profit_loss_contradiction",
    question: "If a quarter shows profit but YTD shows loss (or vice versa), is this clearly explained in the report?"
  },
  {
    id: "columnar_description_accuracy",
    question: "In columnar results, are standalone and consolidated descriptions accurate?",
    subQuestion: "Example: impairment in standalone should not incorrectly appear as goodwill in consolidated"
  },
];

